<!-- 团队风采 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_team.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="团队风采" en="TEAM STYLE"></sub-title>
        <img
          src="../../assets/arrow-left.png"
          class="arrow left"
          :style="{ opacity: swiperIdx == 0 ? 0.1 : 1 }"
          @click="turnLeft"
        />
        <img
          src="../../assets/arrow-right.png"
          class="arrow right"
          :style="{ opacity: swiperIdx == list.length - 1 ? 0.1 : 1 }"
          @click="turnRight"
        />
        <div id="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, idx) in list" :key="idx">
              <div class="box">
                <div class="item" v-for="(val, index) in item" :key="index">
                  <img
                    :src="URL + val.newsImageUrl"
                    :alt="val.title"
                    class="post"
                  />
                  <div class="desc">{{ val.title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      swiper: null,
      swiperIdx: 0,
      list: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getTeamStyleList();
      const maxLen = Math.ceil(res.data.length / 6);
      for (let i = 0; i < maxLen; i++) {
        this.list.push(
          res.data.filter((ele, idx) => idx >= i * 6 && idx <= 6 * i + 5)
        );
      }
      setTimeout(() => {
        this.initSwiper();
      }, 100);
    },
    initSwiper() {
      let vm = this;
      this.swiper = new window.Swiper("#swiper", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange() {
            vm.swiperIdx = this.activeIndex;
          },
        },
      });
    },
    turnLeft() {
      if (this.swiperIdx == 0) return;
      this.swiper.slidePrev();
    },
    turnRight() {
      if (this.swiperIdx == this.list.length - 1) return;
      this.swiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/organization_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;
    position: relative;

    .arrow {
      width: 28px;
      position: absolute;
      top: calc(50% + 63px);
      transform: translateY(-50%);
      cursor: pointer;
    }
    .left {
      left: -66px;
    }
    .right {
      right: -66px;
    }

    #swiper {
      width: 100%;
      margin: 60px 0 70px;
      position: relative;
      overflow: hidden;

      .box {
        padding: 5px 0;
        display: flex;
        flex-wrap: wrap;

        .item {
          margin: 0 5px 30px;
          box-shadow: 0 0 5px #999;

          .post {
            width: 390px;
            height: 390px;
            object-fit: contain;
          }
          .desc {
            width: 390px;
            min-height: 80px;
            background-color: #f1f3f5;
            text-align: center;
            color: #5e5d5d;
            font-size: 20px;
            padding: 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}

@media (max-width: 1440px) {
  .frame .container {
    .left {
      left: 35px;
    }
    .right {
      right: 35px;
    }
    #swiper {
      width: 1000px;
      margin: 60px auto 70px;

      .box .item {
        .post {
          width: 323px;
          height: 323px;
        }
        .desc {
          width: 323px;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .arrow {
        z-index: 111;
      }
      #swiper {
        width: 100%;
        margin: 20px 0;

        .box {
          .item {
            width: calc(50% - 10px);

            .post {
              width: 100%;
              height: 165px;
            }
            .desc {
              width: 100%;
              font-size: 14px;
              min-height: 50px;
            }
          }
        }
      }
    }
  }
}
</style>
